import {Tabs} from '@sollapay/ui';
import {useTranslation} from 'react-i18next';

import type {TrustAccountViewTab} from './TrustAccountViewHeader';
import type {TabItem} from '@sollapay/ui';
import type {FC} from 'react';

/** `showsPayoutsTab` is resolved by the caller — this component also renders during the loading skeleton, with no trust context of its own. */
export interface TrustAccountViewTabsProps {
  buyersCount: number;
  transactionsCount: number;
  documentsCount: number;
  beneficiariesCount: number;
  payoutsCount: number;
  paymentInstructionsCount: number;
  value: TrustAccountViewTab;
  onValueChange: (value: TrustAccountViewTab) => void;
  showsPayoutsTab?: boolean;
}

export const TrustAccountViewTabs: FC<TrustAccountViewTabsProps> = ({
  buyersCount,
  transactionsCount,
  documentsCount,
  beneficiariesCount,
  payoutsCount,
  paymentInstructionsCount,
  value,
  onValueChange,
  showsPayoutsTab = false
}) => {
  const {t} = useTranslation('trustAccounts');
  const allTabs: Array<TabItem | null> = [
    {value: 'overview', icon: 'line-chart', label: t('view.tabs.overview')},
    {value: 'buyers', icon: 'users', label: t('view.tabs.buyers'), count: buyersCount},
    {
      value: 'instructions',
      icon: 'credit-card-down',
      label: t('view.tabs.instructions'),
      count: paymentInstructionsCount
    },
    showsPayoutsTab
      ? {
          value: 'payouts',
          icon: 'credit-card-up',
          label: t('view.tabs.payouts'),
          count: payoutsCount
        }
      : null,
    {
      value: 'transactions',
      icon: 'currency',
      label: t('view.tabs.transactions'),
      count: transactionsCount
    },
    {value: 'documents', icon: 'file', label: t('view.tabs.documents'), count: documentsCount},
    {
      value: 'beneficiaries',
      icon: 'coins-swap',
      label: t('view.tabs.beneficiaries'),
      count: beneficiariesCount
    }
  ];
  const tabs = allTabs.filter((tab): tab is TabItem => tab !== null);

  return (
    <Tabs
      tabs={tabs}
      value={value}
      onValueChange={val => onValueChange(val as TrustAccountViewTab)}
      variant="primary"
      listClassName="w-full"
      hideBorder
    />
  );
};
